import { GroupingColumn } from '@/cip/Optimizer/OptimizationResults/TradeExecution/TradeExecution';

import { type EnrichedOptimizerTrade } from '../../../_openapi/portfolio-optimizer';

export enum TradeSide {
    BUY = 'buy',
    SELL = 'sell',
}

export const getTradeAggregates = (trades: EnrichedOptimizerTrade[]) => {
    return {
        tradesCount: trades.length,
        totalQuantity: trades.reduce((result, trade) => result + Math.abs(trade.tradeQuantity), 0),
        totalValue: trades.reduce((result, trade) => result + (trade.tradeValue ?? 0), 0),
    };
};

export const getTradeSide = (trade: EnrichedOptimizerTrade): TradeSide | undefined => {
    if (trade.tradeQuantity > 0) {
        return TradeSide.BUY;
    }
    if (trade.tradeQuantity < 0) {
        return TradeSide.SELL;
    }
    return undefined;
};

export const getTradeValueAsPercentOfNav = (trade: EnrichedOptimizerTrade): number | undefined => {
    if (trade.tradeValue === undefined || trade.nav === undefined) {
        return undefined;
    }
    return trade.tradeValue / trade.nav;
};

export interface CommonTradePlanEntry {
    trades: EnrichedOptimizerTrade[];
    tradesCount: number;
    totalQuantity: number;
    totalValue: number;
}

export interface TradeTableProps {
    secondaryGrouping?: GroupingColumn;
    filteredTrades: EnrichedOptimizerTrade[] | undefined;
    excludeTrades: (trades: EnrichedOptimizerTrade[]) => void;
    viewAsset: (sId: string) => void;
    viewPortfolio: (pId: string) => void;
    viewTrade: (trade: EnrichedOptimizerTrade) => void;
    viewAdvanced: (portfolioGuid: string, pId: string) => void;
}
